import React, { useEffect } from 'react';

const Page401 = () => {
  useEffect(() => {
    document.title = 'Protected page';
  }, []);

  return (
    <div className="utility-page-wrap">
      <div className="utility-page-content w-password-page w-form">
        <form
          action="/.wf_auth"
          method="post"
          id="email-form"
          name="email-form"
          data-name="Email Form"
          className="utility-page-form w-password-page"
        >
          <img
            src="https://d3e54v103j8qbb.cloudfront.net/static/utility-lock.ae54711958.svg"
            alt=""
          />
          <h2>Dold Sida</h2>
          <label htmlFor="pass" className="w-password-page">
            Lösenord
          </label>
          <input
            className="w-password-page w-input"
            autoFocus={true}
            maxLength="256"
            name="pass"
            data-name="field"
            placeholder="Ange ditt lösenord"
            type="password"
            id="pass"
          />
          <input
            type="submit"
            data-wait="Please wait..."
            className="w-password-page w-button"
            value="Skicka"
          />
          <div className="w-password-page w-form-fail">
            <div>Incorrect password. Please try again.</div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Page401;
